export const URLS = {
    PRODUCTS_API: 'https://fakestoreapi.com',
    PRODUCTS_PATH: 'products',
}

